export default [{
	titulo: 'Fornecedores',
	icone: 'menu-icon fa fa-caret-right',
	url: '/servicos/fornecedores',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]